import { Component, ViewChild, ElementRef, AfterViewInit, AfterContentInit,OnInit } from '@angular/core';
import { Mode, ResponseStatus } from 'src/core/utility/enums/enums';
import { NgForm, NgModel } from '@angular/forms';
import { Helper } from 'src/core/utility/helper/helper';
import { Member } from '../../models/member';
import { NewslettersService } from '../../services/news-letter.service';
import { OutputResponse } from '../../models/response';

@Component({
  selector: 'adahi-news-letter',
  templateUrl: './news-letter.component.html'
})
export class NewsLetterComponent implements OnInit {

  @ViewChild('newsLetterForm')
  form: NgForm;
  @ViewChild('adahiForm')
  adahiForm: ElementRef;
  @ViewChild('email')
  emailControl: NgModel;

  public status: Mode = Mode.None;
  public enumMode = Mode;
  submitted = false;
  logedinEmail="";
  showMSG=false;
  newsletters:string;
  lastExistEmail: string="";
  lastSubscribedEmail: string="";
  isAnonymous: boolean = true;
  isEmailChecked: boolean = false;
  isEmailNotSubscribed:boolean=false;
  isEmailExists: boolean = false;
  Member: Member;


  constructor(private service: NewslettersService) { 
    this.Member = new Member();
    
  }

  ngOnInit() {

    if (_spPageContextInfo.userId == null) {
      this.isAnonymous = true;
  }

  else {
      this.isAnonymous = false;
      this.logedinEmail=_spPageContextInfo.userLoginName;
      
  }
  
  }

  onSubscribe(){
    this.newsletters='subscribed';
    this.submitted = true;
    this.showMSG=false;
    //this.lastExistEmail = "";
    //this.isEmailChecked = null;
    
    if (this.form.valid && !this.isEmailExists) {

         this.lastExistEmail = "";
         this.isEmailExists=false;
         this.isEmailChecked = null;
         
            this.Member.email_address = this.form.value.email.toLowerCase();
         

            this.Member.status = this.newsletters;

    
        this.service.subscription(this.Member).subscribe(this.onSubscriptionSuccess,this.onSubscriptionError);
      
    }
    else {
      Helper.focusOnError(this.adahiForm);
    }
  }

  

  onUnSubscribe(){
    this.newsletters='unsubscribed';
    this.submitted = true;
    this.showMSG=false;
    //this.lastSubscribedEmail = "";
    //this.isEmailChecked = null;

if (this.form.valid && !this.isEmailNotSubscribed) {
           this.lastSubscribedEmail = "";
           this.isEmailNotSubscribed=false;
           this.isEmailChecked = null;
            this.Member.email_address = this.form.value.email.toLowerCase();
         

            this.Member.status = this.newsletters;

    
        this.service.unSubscription(this.Member).subscribe(this.onUnSubscriptionSuccess,this.onUnSubscriptionError);
      
    }
    else {
      Helper.focusOnError(this.adahiForm);
    }
  }

  
  onSubscriptionSuccess = (response) => {
    let _response: OutputResponse = response as OutputResponse;

      if (_response.subStatus == ResponseStatus.Success) {
        this.status = Mode.Success;
        this.isEmailExists = false;
        this.lastExistEmail = "";
        this.isEmailNotSubscribed = false;
    this.lastSubscribedEmail= "";
        this.emailControl.control.setValue("");
        this.submitted=false;
        this.showMSG = true;
        setTimeout(() => {
          this.showMSG=false;
        }, 2500);
      }
      else {
          if (_response.subStatus == ResponseStatus.EmailExists) {
            this.isEmailExists = true;
            this.lastExistEmail = this.form.value.email;
          }
      }
    
}

onSubscriptionError = () => {
    this.status = Mode.Error;
    this.isEmailExists= false;
    this.lastExistEmail = "";
    this.isEmailNotSubscribed = false;
    this.lastSubscribedEmail= "";
    this.emailControl.control.setValue("");
    this.submitted=false;
    this.showMSG=true;
        setTimeout(() => {
          this.showMSG=false;
        }, 2500);
}

onUnSubscriptionSuccess = (response) => {
  let _response: OutputResponse = response as OutputResponse;

  if (_response.subStatus == ResponseStatus.Success) {
    this.status = Mode.Success;
        this.isEmailNotSubscribed = false;
        this.lastSubscribedEmail = "";
        this.isEmailExists= false;
        this.lastExistEmail= "";
        this.emailControl.control.setValue("");
        this.submitted=false;
        this.showMSG=true;
        setTimeout(() => {
          this.showMSG=false;
        }, 2500);
    
  }
  else {
      if (_response.subStatus == ResponseStatus.EmailExists) {
        this.isEmailNotSubscribed = true;
        this.lastSubscribedEmail = this.form.value.email;

      }
  }
  
}

onUnSubscriptionError = () => {
    this.status = Mode.Error;
    this.isEmailNotSubscribed = false;
    this.lastSubscribedEmail= "";
    this.isEmailExists= false;
    this.lastExistEmail= "";
    this.emailControl.control.setValue("");
    this.submitted=false;
    this.showMSG=true;
        setTimeout(() => {
          this.showMSG=false;
        }, 2500);
  
}

emailChange()
{
    this.isEmailChecked = false;
    if (this.form.value.email.toLowerCase() == this.lastExistEmail.toLowerCase()||this.form.value.email.toLowerCase() == this.lastSubscribedEmail.toLowerCase()) {
      if(this.newsletters=='subscribed'){
        this.isEmailExists = true;
      }
      else{
        this.isEmailNotSubscribed = true;
      }
        this.isEmailChecked = true;
    }

    else {
      if(this.newsletters=='subscribed'){
        this.isEmailExists = false;
      }
        this.isEmailNotSubscribed = false;
    }
}

}
